// Exports true if environment provides native `Set` implementation,
// whatever that is.

"use strict";

module.exports = (function () {
	if (typeof Set === "undefined") return false;
	return Object.prototype.toString.call(Set.prototype) === "[object Set]";
})();
